import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';
const MagicLink = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Token não encontrado. Verifique o link recebido por email.');
        return;
      }
      try {
        const response = await authService.verifyMagicLink(token);
        setStatus('success');
        setMessage(response.message || 'Login realizado com sucesso!');
        // Redirect to home after a delay
        setTimeout(() => {
          navigate('/');
          // Dispatch storage event to update authentication state
          window.dispatchEvent(new Event('storage'));
        }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Erro ao verificar link. O token pode ser inválido ou ter expirado.');
      }
    };
    verifyToken();
  }, [token, navigate]);
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-1307" data-mp="2pde3lm6qrat5">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md" data-id="element-1308" data-mp="2keb9gwsauozy">
        <h1 className="text-2xl font-bold text-center mb-6" data-id="element-1309" data-mp="2fkowf3i84j3m">
          Login com Magic Link
        </h1>
        <div className="flex flex-col items-center justify-center space-y-4" data-id="element-1310" data-mp="2bkeohlavfim4">
          {status === 'loading' && <>
              <Loader2 size={48} className="text-[#1649ff] animate-spin" data-id="element-1311" data-mp="26iz6k23zps7y" />
              <p className="text-gray-600 text-center" data-id="element-1312" data-mp="21kxkd8b9pcs9">
                Verificando seu link de acesso...
              </p>
            </>}
          {status === 'success' && <>
              <CheckCircle size={48} className="text-green-500" data-id="element-1313" data-mp="1n138t7z8n2k1" />
              <p className="text-green-600 text-center font-medium" data-id="element-1314" data-mp="1rz4ttyg85by5">
                {message}
              </p>
              <p className="text-gray-500 text-center" data-id="element-1315" data-mp="1dzwnmlln93kg">
                Você será redirecionado automaticamente em alguns segundos...
              </p>
            </>}
          {status === 'error' && <>
              <AlertCircle size={48} className="text-red-500" data-id="element-1316" data-mp="25ruf20nxicu7" />
              <p className="text-red-600 text-center font-medium" data-id="element-1317" data-mp="2an9siri0y6q3">{message}</p>
              <button onClick={() => navigate('/')} className="mt-4 px-4 py-2 bg-[#1649ff] text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-1318" data-mp="1wxzg5adehin0">
                Voltar para a página inicial
              </button>
            </>}
        </div>
      </div>
    </div>;
};
export default MagicLink;